<template>
    <div >
        <!--<breadcrumb :routerList="[{to:'/agent/weekMeetingAccount',title:'签约经销商周清会控制台账'}]"/>-->
        <Breadtabsheader/>
        <div class="h-content">
            <!-- 搜素条件 -->
            <div class="h-piece">
                <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                    <div class="h-thirdColumn w-newColumn">
                        <el-form-item label="经销商编码">
                            <el-input v-model="q.agentCode" :clearable="true"></el-input>
                        </el-form-item>
                        <el-form-item label="经销商名称">
                            <el-input v-model="q.agentName" :clearable="true"></el-input>
                        </el-form-item>
                        <el-form-item label="所属年月" prop="yearMonth" >
                            <div class="block">
                                <el-date-picker
                                        v-model="q.yearMonth"
                                        type="month"
                                        value-format="yyyy-MM"
                                        placeholder="选择月">
                                </el-date-picker>
                            </div>
                        </el-form-item>
                      <el-form-item label="区域">
                        <el-select filterable v-model="q.areaCode" clearable placeholder="请选择"
                        >
                          <el-option
                              v-for="(item,index) in areaList"
                              :key="item.name"
                              :label="item.name"
                              :value="item.name">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </div>

                  <el-collapse-transition>
                    <div v-show="isScreen">
                      <div class="h-thirdColumn w-newColumn">
                        <el-form-item label="渠道">
                          <el-select filterable v-model="q.channelCode" clearable placeholder="请选择"
                          >
                            <el-option
                                v-for="(item,index) in channelList"
                                :key="item.name"
                                :label="item.name"
                                :value="item.name">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="运营人">
                          <el-input v-model="q.conveneName" :clearable="true"></el-input>
                        </el-form-item>
                      </div>
                    </div>
                  </el-collapse-transition>


                </el-form>
                <div class="l-screenBox">
                  <div class="l-screen" @click="collapseChange">
                    <img :src="isScreen?closeScreen:drawScreen" alt="">
                    <div class="l-screenText">{{isScreen?"收起":"下拉"}}</div>
                  </div>
                    <div class="l-retrieval">
                        <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                        <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置
                        </el-button>
                    </div>
                </div>
            </div>

            <div class="h-table h-mrt30">
                <el-table
                        ref="ddtable"
                        :data="tableData"
                        @selection-change="handleSelectionChange"
                        stripe
                        border
                        style="width: 100%">
                    
                    <el-table-column
                            type="index"
                            width="40"
                            label="序号"
                            fixed >
                    </el-table-column>
                    <el-table-column
                            prop="area"
                            label="区域"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="field"
                            label="领域"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="channelName"
                            label="渠道"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="agentCode"
                            label="经销商编码"
                            width="120">
                    </el-table-column>
                    <el-table-column
                            prop="agentName"
                            label="经销商名称"
                            width="180">
                    </el-table-column>

                    <el-table-column
                            prop="weekYear"
                            label="经销商周清会时间"
                            width="140">
                        <template slot-scope="scope">
                            {{ scope.row.weekYear }}-{{ scope.row.weekMonth }}
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="conveneName"
                            label="运营人"
                            width="110">
                    </el-table-column>
                    <template v-for="(column, index) in weekList">
                        <el-table-column
                                v-bind="column"
                                :label="column.weekStr"
                                :prop="column.weekStr"
                                :key="column.id"
                        >
                            <template slot="header" scope="scope">
                                <span >{{column.weekStr}}</span>
                            </template>

                            <el-table-column
                                    prop="haveMeeting"
                                    label="有无运营输出"
                                    width="110">
                                <template slot-scope="scope">
                                    {{ scope.row[column.week+"haveMeeting"]}}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="haveMeetingPhoto"
                                    label="有无会议照片"
                                    width="110">
                                <template slot-scope="scope">
                                    {{ scope.row[column.week+"haveMeetingPhoto"]}}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="score"
                                    label="评价"
                                    width="110">
                                <template slot-scope="scope">
                                    {{ scope.row[column.week+"score"]}}
                                 </template>
                            </el-table-column>
                        </el-table-column>

                    </template>

                 <!--   <el-table-column >
                        <template slot="header" scope="scope">
                            <span >{{"周1输出2222"}}</span>
                        </template>

                        <el-table-column
                                prop="haveMeeting"
                                label="有无运营输出"
                                width="110">
                        </el-table-column>
                        <el-table-column
                                prop="haveMeetingPhoto"
                                label="有无会议照片"
                                width="110">
                        </el-table-column>
                        <el-table-column
                                prop="score"
                                label="评价"
                                width="110">
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="周2输出">
                        <el-table-column
                                prop="haveMeeting2"
                                label="有无运营输出"
                                width="110">
                        </el-table-column>
                        <el-table-column
                                prop="haveMeetingPhoto2"
                                label="有无会议照片"
                                width="110">
                        </el-table-column>
                        <el-table-column
                                prop="score2"
                                label="评价"
                                width="110">
                        </el-table-column>
                    </el-table-column>
-->


                </el-table>
                <div class="h-tableB h-mrt30">
                    <div class="h-tableBL">
                        <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcel">批量导出</el-button>
                    </div>
                    <div class="h-pagination2">
                        <pagination :page="q" @query="query" />
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
<script>

    import weekMeetingService from "../../../../api/loud/weekMeeting/weekMeetingService.js";
    import ss from "../../../../api/SystemService";
    import moment from "moment";
    import engTable from "../../../../api/dingd/ProductEngTable";
    import updownfile from "../../../../utils/updownfile";
    export default {
        components: {},
        data() {
            return {
                // 展开折叠筛选
                isScreen:false,
                closeScreen:require("@/assets/images/pimg/closeallic.png"),
                drawScreen:require("@/assets/images/pimg/dobleArr.png"),
                //查询属性
                q: {
                    agentCode:null,
                    agentName:null,
                    yearMonth:null,
                    channelCode:'',
                    conveneName:'',
                    areaCode:'',
                    score:'',
                    weekMonth:'',
                    delflag:1,
                    pageSize:10,
                    pageNo:1,
                    total:0,
                },
                //表单
                f:{
                    agentCode:null, // 经销商编码
                    agentName:null, // 经销商名称
                    channel:null, // 经销商渠道
                    weekTime:null, // 运营会时间
                    weekStr:null, //周范围字符串
                    conveneCode:null, // 召开人编码
                    conveneName:null, // 召开人名称
                    participants:null, // 参会人员
                    month:null, // 月份
                    monthTarget:null, // 本月目标
                    monthExpect:null, // 本月预计达成
                    completionRate:null, // 履约率
                    monthTotal:null, // 本月累计（万）
                    nextWeekExpect:null, // 下周预计下单（万）
                    nextWeekExpectYb:null, // 下周预计下单-样本网
                    nextWeekExpectYp:null, // 下周预计下单-药品网
                    nextWeekExpectYy:null, // 下周预计下单-云眼网
                    nextWeekExpectPyx:null, // 下周预计下单-培养箱
                    nextWeekExpectLxj:null, // 下周预计下单-离心机
                    nextWeekExpectUsj:null, // 下周预计下单-U试剂
                    keyTask:null, // 重点任务描述
                    weekProgressSummary:null, // 本周进展总结
                    nextWeekPlan:null, // 下周计划
                    weekHighlight:null, // 本周亮点
                    competitorAnalysis:null, // 对手分析
                    problemDescription:null, // 问题描述
                    collaborator:null, // 协同人
                    arrivalTime:null, // 到位时间
                    score:null, // 评分
                    summarize:null, // 总结

                },
                tableSelectedList:[],
                //table列表
                tableData: [],
                weekList :[],
                monthList:["01","02","03","04","05","06","07","08","09","10","11","12"],
                areaList:[],
                channelList:[],
                yearList:[new Date().getFullYear()-1,new Date().getFullYear(),new Date() .getFullYear()+1],
                //是否管理员
                adminFlag:false,
            }
        },
        created() {
            if(this.$store.getters.hasRole('swyl_admin')||this.$store.getters.hasRole('swyl_wanglgly')){
                this.adminFlag = true;
            }

            this.channelList = this.$store.getters.dictlist("sales_region");
            this.areaList = this.$store.getters.dictlist("YLRegion");
            this.query();
        },
        methods: {
          // 展开折叠
          collapseChange(){
            this.isScreen = !this.isScreen;
          },
            query() {
                weekMeetingService.selectMeetingReport(this.q).then(rd=>{
                    this.q.total = rd.pageList.total;
                    this.tableData = rd.pageList.records;

                    this.$set(this, "weekList",rd.weekList);

                    console.log("weekList",this.weekList);

                })
            },
            handleFilter() {
                this.query();
            },

            handleSelectionChange(lists){
                this.tableSelectedList = lists;
            },
            resetData(){
                var pageSize=this.q.pageSize;
                var pageNo=this.q.pageNo;
                var total=this.q.total;
                this.q= {
                    agentName:null,
                    agentCode:null,
                    yearMonth:null,
                    channelCode:null,
                    conveneName:null,
                    creationTime:null,
                    score:null,
                    weekMonth:null,
                    pageSize: pageSize,
                    pageNo: pageNo,
                    total:total,
                }
            },


            //批量导出
            exportExcel(){

                let data= {};
                data.agentName =this.q.agentName;
                data.agentCode =this.q.agentCode;
                data.yearMonth =this.q.yearMonth;

                updownfile.down("/api/swyl/v1/agent/bscAgentWeekMeeting/meetingReportDownloadExcel",this.q,"get",'data22');
            },

        }
    }
</script>
